import { isString } from '../utils/StringUtils';

export const replaceSlash = (value?: string) => {
  if (value === undefined || !isString(value) || value.length === 0) {
    return value;
  }
  if (value.includes('//')) {
    const [protocol, ...rest] = value.split('//');
    const url = rest.join('//').replace(/\/$/, '').replaceAll('/', ' › ');
    return `${protocol}//${url}`;
  } else {
    return value.replace(/\/$/, '').replaceAll('/', ' › ');
  }
};
